import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';

export const LibraryError = ({ reload }: { reload?: () => void }) => (
  <div className="w-full h-full flex flex-col gap-6 justify-center items-center">
    <Typography variant="headline" size="medium">
      Something went wrong{' '}
    </Typography>
    <Typography
      color="N-80"
      variant="body"
      size="large"
      className="w-full md:w-[494px] text-center"
    >
      Unexpected error occurred. We’ve been notified and will get started on a
      fix.
    </Typography>
    <Button color="neutral" onClick={() => reload && reload()}>
      Reload this page
    </Button>
  </div>
);
